import React, { memo } from "react"
import { LagNode as LagNodeType } from "@features/builder/graph/types"
import NodeContainer from "./NodeContainer"

export const LagNode = memo((node: LagNodeType) => {
  return (
    <NodeContainer node={node}>
      <div className="graph-node-container">
        <div className="graph-node-type graph-node-lag">{node.type}</div>
        <div className="graph-node-label">{node.data.label}</div>
      </div>
    </NodeContainer>
  )
})

LagNode.displayName = "LagNode"
